
export const clearFilterParams = (): void => {
  const currentLocation = new URLSearchParams(location.search)
  const keysToDelete: string[] = []

  for (const [key] of currentLocation.entries()) {
    if (key.startsWith('filter.') || key === 'page' || key.startsWith('sort.')) {
      keysToDelete.push(key)
    }
  }

  keysToDelete.forEach((key) => currentLocation.delete(key))

  const newUrl = `${window.location.pathname}?${currentLocation.toString()}`
  window.history.replaceState({}, '', newUrl)
}